"use strict";

(function () {
  'use strict';

  angular.module('lr.DataStream').factory('DataStreamFactory', DataStreamFactory).constant('dataEvents', {
    newEvent: 'dataEvents:new',
    propertyState: 'dataEvents:propertyState'
  });
  DataStreamFactory.$inject = ['$rootScope', 'User', 'dataEvents', '$http', '$q', 'api', 'Utils', 'EventSettingsFactory', 'eventTypes', 'MessageController', 'SocketBridge'];
  /* @ngInject */

  function DataStreamFactory($rootScope, User, dataEvents, $http, $q, api, Utils, EventSettingsFactory, eventTypes, MessageController, SocketBridge) {
    var DEFAULTS = {
      nameSpace: '/datastream'
    };
    var _listeners = [];
    var DataStream = {};
    DataStream.events = [];
    DataStream.unseenEvents = [];
    DataStream.nameSpace = DEFAULTS.nameSpace;
    /**
     *
     * @param nameSpace
     */

    DataStream.setNameSpace = function setNameSpace(nameSpace) {
      this.nameSpace = nameSpace;
    };
    /**
     * when new events come in they are added to the unseenEvents array
     * after a user views the events. This function is called
     */


    DataStream.resetUnseenEvents = function resetUnseenEvents() {
      this.unseenEvents = [];
    };
    /**
     * fetch event history (stored in couchDB)
     * @param date date to look at
     * @param page page count
     * @param pageDataID
     * @returns {Function|promise}
     */


    DataStream.fetchHistory = function (date, page, pageDataID) {
      var deferred = $q.defer();

      var _this = this;

      DataStream.getEvents(date, page, pageDataID).then(function (data) {
        if (data.data.length >= 0) {
          _this.events = data.data;
          deferred.resolve(data);
        } else {
          deferred.reject(data);
        }
      }, function (data) {
        deferred.reject(data);
      });
      return deferred.promise;
    }; // isolated scope, doesnt mutate the events data


    DataStream.getEvents = function (date, page, pageDataID) {
      var deferred = $q.defer();
      var temp = new Date(Utils.DateKeeper.getDate().getTime());
      var today = Utils.lrDateFormat(date) || Utils.lrDateFormat(Utils.DateKeeper.getDate());
      var yesterDay = Utils.lrDateFormat(date) || Utils.lrDateFormat(temp.setDate(temp.getDate() - 30));
      pageDataID = pageDataID || null;

      if (User.isAuthenticated()) {
        var user = User.getToken();
        var sendData = {
          StartQueryDate: yesterDay,
          EndQueryDate: null,
          //null for now since we only query todays date.
          LiveRezEventTypeIDs: EventSettingsFactory.getLiveRezEventTypeIDs(),
          Start: page,
          PageSize: 200,
          PageDataID: pageDataID
        };
        $http.post(api.proxy + '/Automation/Event/List', sendData, {
          cache: true
        }).then(function (data) {
          if (data.data.length >= 0) {
            data.data.map(function (event) {
              event.dateOccurredTicks = new Date(event.dateOccurred).getTime();
            });
            deferred.resolve(data);
          } else {
            deferred.reject(data);
          }
        }, function (data) {
          deferred.reject(data);
        });
      } else {
        deferred.reject();
      }

      return deferred.promise;
    };
    /**
     * init the data stream
     * setup the socket connections
     * setup socket event subscribers
     */


    DataStream.init = function () {
      var _this = this;

      SocketBridge.controller.subscribe('application-notification', 'realtimemanagerAPP');

      _listeners.push(MessageController.subscribe('application-notification', function (message) {
        $rootScope.$apply(function () {
          if (_dashboardEvent(message.liveRezEventTypeID)) {
            Utils.Publisher.publish(dataEvents.propertyState, message); // MessageController.publish([message.payload.liveRezApplication, message.payload.liveRezType, message.payload.action].join('-'), message);
          }

          _this.events.unshift(message);

          _this.unseenEvents.unshift(message);

          Utils.Publisher.publish(dataEvents.newEvent, message);
        });
      }));
    };

    DataStream.unsubscribe = function () {
      var _this = this;

      _this.events.length = 0;
      _this.unseenEvents.length = 0;

      _listeners.forEach(function (listener) {
        MessageController.unsubscribe(listener);
      });

      _listeners.length = 0;
      SocketBridge.controller.unsubscribe('application-notification', 'realtimemanagerAPP');
    };

    var service = {
      generator: function generator() {
        return DataStream;
      }
    }; ////////////////

    function _dashboardEvent(event) {
      //add dashboard events here
      var supportedEvents = [eventTypes.CleaningStarted, eventTypes.CleaningCompletedSuccessfully, eventTypes.CleaningCompletedWithProblems, eventTypes.CleaningCanceled, eventTypes.InspectionStarted, eventTypes.InspectionCompletedSuccessfully, eventTypes.InspectionCompletedWithProblems, eventTypes.InspectionCanceled, eventTypes.MaintenanceStarted, eventTypes.MaintenanceCompletedSuccessfully, eventTypes.MaintenanceCompletedWithProblems, eventTypes.MaintenanceCanceled, eventTypes.PropertyFlagStarted, eventTypes.PropertyFlagResolved, eventTypes.GuestCheckIn, eventTypes.GuestCheckOut, eventTypes.PropertyFlagStarted, eventTypes.PropertyFlagResolved];

      if (supportedEvents.indexOf(event) > -1) {
        return true;
      } else {
        return false;
      }
    }

    return service;
  }
})();